var _excluded = ["as", "children", "align", "inlineAlign", "gap", "id", "reverseOrder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classNames, getResponsiveProps, sanitizeCustomProperties } from '../../utilities/css.js';
import styles from './VerticalStack.scss.js';

var VerticalStack = function VerticalStack(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      children = _ref.children,
      align = _ref.align,
      inlineAlign = _ref.inlineAlign,
      gap = _ref.gap,
      id = _ref.id,
      _ref$reverseOrder = _ref.reverseOrder,
      reverseOrder = _ref$reverseOrder === void 0 ? false : _ref$reverseOrder,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var className = classNames(styles.VerticalStack, (as === 'ul' || as === 'ol') && styles.listReset, as === 'fieldset' && styles.fieldsetReset);

  var style = _objectSpread({
    '--pc-vertical-stack-align': align ? "".concat(align) : '',
    '--pc-vertical-stack-inline-align': inlineAlign ? "".concat(inlineAlign) : '',
    '--pc-vertical-stack-order': reverseOrder ? 'column-reverse' : 'column'
  }, getResponsiveProps('vertical-stack', 'gap', 'space', gap));

  return /*#__PURE__*/React.createElement(as, _objectSpread({
    className: className,
    style: sanitizeCustomProperties(style)
  }, restProps), children);
};

export { VerticalStack };